import { MISC, NP_NP, TO_BE_INITIATED, NOT_SETTLED, SETTLED } from "../constants/constants"
export const orderData =
[
    {
        "Id": 1,
        "OrderId": 123,
        "SettlementId": 1,
        "CollectorAppId": "buyer-app-preprod-v2.ondc.org",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "Amount": {
            "Currency": "INR",
            "Value": "100"
        },
        "ReconciliationRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",
        "Remarks": "test"
    },
    {
        "Id": 2,
        "OrderId": 345,
        "SettlementId": 1,
        "CollectorAppId": "buyer-app-preprod-v2.ondc.org",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "Amount": {
            "Currency": "INR",
            "Value": "1000"
        },
        "ReconciliationRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",
        "Remarks": "test"
    },
    {
        "Id": 3,
        "OrderId": 245,
        "SettlementId": 1,
        "CollectorAppId": "buyer-app-preprod-v2.ondc.org",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "Amount": {
            "Currency": "INR",
            "Value": "240"
        },
        "ReconciliationRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2023-10-10T12:27:34.410Z",
        "UpdatedOnUtc": "2023-10-10T12:27:34.410Z",
        "Remarks": "test"
    }
]